import button from '../Button/variants';
import checkbox from '../Checkbox/variants';
import chip from '../Chip/variants';
import formControlLabel from '../FormControlLabel/variants';
import iconButton from '../IconButton/variants';
import outlinedInput from '../OutlinedInput/variants';
import radio from '../Radio/variants';
import step from '../Step/variants';
import switch_ from '../Switch/variants'; // "switch" is reserved JS word
import tab from '../Tab/variants';
import tableRow from '../TableRow/variants';
import tabs from '../Tabs/variants';
import pane from '../Pane/variants';
import dialogActions from '../DialogActions/variants';
import link from '../Link/variants';
import listItem from '../ListItem/variants';
import listItemIcon from '../ListItemIcon/variants';
import listItemText from '../ListItemText/variants';
import container from '../Container/variants';
import menu from '../Menu/variants';
import toggleButton from '../ToggleButton/variants';
import toggleButtonGroup from '../ToggleButtonGroup/variants';
import typography from '../Typography/variants';

const variants = {
  button,
  checkbox,
  chip,
  formControlLabel,
  iconButton,
  outlinedInput,
  radio,
  step,
  switch_,
  tab,
  tableRow,
  tabs,
  pane,
  dialogActions,
  link,
  listItem,
  listItemIcon,
  listItemText,
  container,
  menu,
  toggleButton,
  toggleButtonGroup,
  typography,
};

export default variants;
